var map = {
	"./ICONO-HR-PU-2.png": 667,
	"./PopUp Web Muni.png": 668,
	"./adjuntar.png": 617,
	"./admiracion.png": 634,
	"./anexar.png": 669,
	"./arrow-left.png": 642,
	"./ask.png": 613,
	"./ayuda.png": 639,
	"./carta.png": 656,
	"./cartilla.png": 670,
	"./cartilla2.png": 671,
	"./cloud.png": 672,
	"./consulta_azul.png": 648,
	"./consultatutramite.png": 673,
	"./delete.png": 657,
	"./dni-02-01.png": 635,
	"./dni-02-02.png": 636,
	"./download.png": 654,
	"./estadodecuenta.png": 674,
	"./file.png": 640,
	"./flecha_derecha.png": 611,
	"./icono-consultas-linea.png": 675,
	"./icono_save.png": 643,
	"./imagen_mantenimiento.png": 676,
	"./images/calendar.png": 644,
	"./images/logo-muni-azul.png": 677,
	"./institucion.png": 641,
	"./left-arrow-black.png": 678,
	"./left-arrow-blue.png": 652,
	"./like.png": 679,
	"./loader.png": 637,
	"./login.png": 649,
	"./logo-miraflores.png": 638,
	"./logo-miraflores_old.png": 680,
	"./logo.png": 681,
	"./logo_miraflores_fblanco.png": 682,
	"./menu-blue.png": 683,
	"./menu-circle-blue.png": 651,
	"./menu.png": 684,
	"./mesadepartes.png": 650,
	"./nuevotramite.png": 685,
	"./pagoenlinea.png": 686,
	"./pdf.png": 609,
	"./personajuridica.png": 658,
	"./personanatural.png": 659,
	"./print_white_bold.png": 660,
	"./question.png": 655,
	"./requisito.png": 687,
	"./right-arrow-black.png": 688,
	"./right-arrow-blue.png": 689,
	"./solicitud.png": 690,
	"./success.png": 607,
	"./tengaEnCuenta.png": 661,
	"./tenis.png": 691,
	"./upload-cloud.png": 692,
	"./user.png": 653,
	"./userRegistro.png": 693
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 663
// module chunks = 0 2 7 8 9 10